import { getLastFileByCreatedAt } from "./getLastFileByCreatedAt";
import { is3DFile } from "./is3DFile";

export const get3DFile = <T extends { url: string; createdAt?: Date | string }>(
  files: T[] | undefined | null,
): T | null => {
  if (!files) {
    return null;
  }

  const files3D = files.filter((file) => is3DFile(file));

  return getLastFileByCreatedAt(files3D) ?? null;
};
